import { MailCheck } from "lucide-react";
import { useState } from "react";
import { Link, useSearchParams } from "react-router";
import { Banner, Button } from "../../components/ui";
import { authClient, authErrorMessage } from "../../lib/auth-client";
import { AuthLayout } from "./AuthLayout";

export function CheckEmailPage() {
  const [params] = useSearchParams();
  const email = params.get("email") ?? "";
  const [status, setStatus] = useState<"idle" | "sending" | "sent" | string>("idle");

  async function resend() {
    setStatus("sending");
    const { error } = await authClient.sendVerificationEmail({ email, callbackURL: "/" });
    setStatus(error ? authErrorMessage(error) : "sent");
  }

  return (
    <AuthLayout title="Confirma tu correo">
      <div className="space-y-4 text-sm text-gray-600">
        <MailCheck className="h-10 w-10 text-gold-500" aria-hidden />
        <p>
          Te enviamos un enlace de confirmación
          {email && (
            <>
              {" "}
              a <strong className="text-gray-900">{email}</strong>
            </>
          )}
          . Ábrelo para activar tu cuenta; vence en 24 horas.
        </p>
        <p>Si no lo ves, revisa tu carpeta de correo no deseado.</p>
        {status === "sent" && <Banner tone="success">Enviamos un nuevo enlace.</Banner>}
        {status !== "idle" && status !== "sending" && status !== "sent" && <Banner tone="error">{status}</Banner>}
        {email && (
          <Button variant="secondary" onClick={resend} loading={status === "sending"}>
            Reenviar correo
          </Button>
        )}
        <p className="text-xs">
          <Link to="/login" className="underline hover:text-gray-900">
            Volver a iniciar sesión
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
}
